export const invalidHashValues = {
  ERROR: 'ERROR',
  NOT_SET: 'NOT SET',
  EMPTY: '-',
};
